export default "__VITE_ASSET__B$xVfu0s__"